// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyAkQVx2GrJKvA5cp9TqfxEDGTQXiDSPvXQ",
    authDomain: "clouds-covid19.firebaseapp.com",
    projectId: "clouds-covid19",
    storageBucket: "clouds-covid19.appspot.com",
    messagingSenderId: "582983164186",
    appId: "1:582983164186:web:f0f279d96d2bbc4bb1cca3",
    measurementId: "G-5JNP4B6C0P"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
